<template>
  <LayoutAdmin>
    <div class="main-content">
      <section class="section">
        <div class="section-header">
          <h1>Lihat Semua Form (Hanya Untuk Development)</h1>
        </div>

        <div class="section-body">
          <div
            class="list-formulir"
            role="tablist"
          >
            <b-card
              no-body
              class="mb-1"
              v-for="f in form"
              :key="f.id"
            >
              <b-card-header
                header-tag="header"
                class="p-0"
                role="tab"
                style="min-height:inherit;border-radius:3px;cursor:pointer"
              >
                <div
                  v-b-toggle="'form-'+f.id"
                  class="p-3 d-flex"
                  :class="{'bg-success text-white' : f.form_data}"
                  style="width:100%;border-radius:3px"
                >
                  <b :class="{'text-primary': !f.form_data, 'text-white':f.form_data}">
                    {{ f.nama_form }} <span
                      v-if="f.is_wajib === 1"
                      class="text-dark"
                    >(Wajib)</span>
                  </b>
                  <div style="margin-left:auto">
                    <i
                      class="fa text mr-2" 
                      :class="{'fa-check-circle' : f.form_data, 'fa-info-circle text-warning' : !f.form_data}"
                    />
                  </div>
                </div>
              </b-card-header>
              <b-collapse
                :id="'form-'+f.id"
                role="tabpanel"
                accordion="list-formulir"
              >
                <b-card-body>
                  <component
                    :is="f.component"
                    @handleSuccess="handleSuccess"
                    :is-wajib="f.is_wajib"
                    :data="f.form_data"
                  />
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </div>
      </section>
    </div>
  </LayoutAdmin>
</template>
<script>
import swal from 'sweetalert'
import LayoutAdmin from './../layouts/Admin.vue'

import FormJenisPelaporan from './../../components/form/Pelaporan/FormJenisPelaporan.vue'
import FormPelaporanKelahiran from './../../components/form/Pelaporan/FormPelaporanKelahiran.vue'
import FormPelaporanCapilLuarNKRI from './../../components/form/Pelaporan/FormPelaporanCapilLuarNKRI.vue'
import FormPelaporanDataOrangtua from './../../components/form/Pelaporan/FormPelaporanDataOrangtua.vue'
import FormPelaporanKematian from './../../components/form/Pelaporan/FormPelaporanKematian.vue'
import FormPelaporanPelapor from './../../components/form/Pelaporan/FormPelaporanPelapor.vue'
import FormPelaporanSaksi from './../../components/form/Pelaporan/FormPelaporanSaksi.vue'
import FormPelaporanLahirMati from './../../components/form/Pelaporan/FormPelaporanLahirMati.vue'
import FormPelaporanPembetulanPembatalanAkta from './../../components/form/Pelaporan/FormPelaporanPembetulanPembatalanAkta.vue'
import FormPelaporanPengakuanAnak from './../../components/form/Pelaporan/FormPelaporanPengakuanAnak.vue'
import FormPelaporanPengangkatanAnak from './../../components/form/Pelaporan/FormPelaporanPengangkatanAnak.vue'
import FormPelaporanPengesahanAnak from './../../components/form/Pelaporan/FormPelaporanPengesahanAnak.vue'
import FormPelaporanPerceraian from './../../components/form/Pelaporan/FormPelaporanPerceraian.vue'
import FormPelaporanPeristiwaPenting from './../../components/form/Pelaporan/FormPelaporanPeristiwaPenting.vue'
import FormPelaporanPerkawinan from './../../components/form/Pelaporan/FormPelaporanPerkawinan.vue'
import FormPelaporanPerubahanNama from './../../components/form/Pelaporan/FormPelaporanPerubahanNama.vue'
import FormPelaporanPerubahanStatusKewarganegaraan from './../../components/form/Pelaporan/FormPelaporanPerubahanStatusKewarganegaraan.vue'
import FormPelaporanSubjekAktaKedua from './../../components/form/Pelaporan/FormPelaporanSubjekAktaKedua.vue'
import FormPelaporanSubjekAktaKesatu from './../../components/form/Pelaporan/FormPelaporanSubjekAktaKesatu.vue'
import FormBiodata from './../../components/form/Biodata/FormBiodata.vue'
import FormBiodataWni from './../../components/form/BiodataWni/FormBiodataWni.vue'
import FormPendaftaranKependudukan from './../../components/form/PendaftaranKependudukan/FormPendaftaranKependudukan.vue'
import FormPendaftaranPerpindahanPenduduk from './../../components/form/PendaftaranPerpindahanPenduduk/FormPendaftaranPerpindahanPenduduk.vue'
import FormSkPindahLuarNegeri from './../../components/form/SkPindahLuarNegeri/FormSkPindahLuarNegeri.vue'
import FormSpPerubahanData from './../../components/form/SpPerubahanData/FormSpPerubahanData.vue'
import FormSpTidakMemilikiDokumen from './../../components/form/SpTidakMemilikiDokumen/FormSpTidakMemilikiDokumen.vue'
import FormSptjmKawinBelumCatat from './../../components/form/SptjmKawinBelumCatat/FormSptjmKawinBelumCatat.vue'
import FormSptjmKelahiran from './../../components/form/SptjmKelahiran/FormSptjmKelahiran.vue'
import FormSptjmSuamiIstri from './../../components/form/SptjmSuamiIstri/FormSptjmSuamiIstri.vue'



export default {
	data() {
		return {
			form: null
		}
	},
	components: {
		LayoutAdmin,
		FormJenisPelaporan,
		FormPelaporanKelahiran,
		FormPelaporanCapilLuarNKRI,
		FormPelaporanDataOrangtua,
		FormPelaporanKematian,
		FormPelaporanPelapor,
		FormPelaporanSaksi,
		FormPelaporanLahirMati,
		FormPelaporanPembetulanPembatalanAkta,
		FormPelaporanPengakuanAnak,
		FormPelaporanPengangkatanAnak,
		FormPelaporanPengesahanAnak,
		FormPelaporanPerceraian,
		FormPelaporanPeristiwaPenting,
		FormPelaporanPerkawinan,
		FormPelaporanPerubahanNama,
		FormPelaporanPerubahanStatusKewarganegaraan,
		FormPelaporanSubjekAktaKedua,
		FormPelaporanSubjekAktaKesatu,
		FormBiodata,
		FormBiodataWni,
		FormPendaftaranKependudukan,
		FormPendaftaranPerpindahanPenduduk,
		FormSkPindahLuarNegeri,
		FormSpPerubahanData,
		FormSpTidakMemilikiDokumen,
		FormSptjmKawinBelumCatat,
		FormSptjmKelahiran,
		FormSptjmSuamiIstri,
	},
	methods: {
		handleSuccess(){
			this.$store.dispatch('showDataPermohonanPenduduk', 84)
		}
	},
	created(){
		this.$store.dispatch('fetchAllFormComponent').then(res => {
			if(res.data.status){
				this.form = res.data.data
			}
		})

		
		this.$store.dispatch('showDataPermohonanPenduduk', 84)
	}
}
</script>